import { queryClient, useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { addEventParticipants } from '../../services';
import type { EventCreateParticipant } from '../../types';
import { getEventParticipantsInfiniteQueryKey, getNodeEventDetailQueryKey } from '../keys';

type AddEventParticipantsVariables = {
  eventId: string;
  participants: EventCreateParticipant[];
};

const defaultErrorHandler = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Something went wrong. Invitations couldn’t been sent.');
};

export const useAddEventParticipants = () =>
  useMutation<undefined, AddEventParticipantsVariables>({
    defaultMutateOnError: defaultErrorHandler,
    async mutationFn({ eventId, participants }) {
      const response = await addEventParticipants({
        body: { participants },
        routeParams: { eventId },
      });

      return response.data;
    },
    async onSuccess(_, { eventId }) {
      await queryClient.invalidateQueries({ queryKey: getEventParticipantsInfiniteQueryKey({ filter: { eventId } }) });
      await queryClient.invalidateQueries({ queryKey: getNodeEventDetailQueryKey({ eventId }) });
    },
  });
